import type { IconDefinition } from '../index.tsx';

export const iconChevronDoubleTop: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconChevronDoubleTop',
  icon: [
    16,
    16,
    [],
    '',
    'M13.8092 9.01907L7.99985 3.22971L2.19046 9.01907L0.585636 7.41424L7.99985 3.01935e-05L15.4141 7.41424L13.8092 9.01907ZM13.8092 15.0191L7.99985 9.22971L2.19046 15.0191L0.585636 13.4142L7.99985 6.00003L15.4141 13.4142L13.8092 15.0191Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
